import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Transaction_Profile } from "../../Connections/Transaction";

import "../../Styles/School.css";

const School = ({
  CityId,
  GradeId,
  SchoolTypeId,
  selectedEducationrOption,
  setSelectedEducationOption,
  setEducationValue,
  close,
}) => {
  const [schoolList, setSchoolList] = useState([]);
  const [searchValue, setSearchValue] = useState();

  console.log(CityId, GradeId, SchoolTypeId);

  useEffect(() => {
    if (searchValue?.length > 1) {
      Transaction_Profile.GetSchools(CityId, GradeId, SchoolTypeId, searchValue)
        .then((res) => {
          if (res[0]) {
            setSchoolList(res[2].data);
          }
        })
        .catch((err) => console.log(err));
    }
  }, [searchValue]);

  return (
    <div className="modal-wrapper mobile-bottom">
      <div className="School">
        <div className="School-inside">
          <div className="School-inside-top">
            <div className="School-inside-top-text">
              <p className="School-inside-top-text-p">نام مدرسه</p>
            </div>

            <div className="School-inside-top-image" onClick={close}>
              <img
                className="School-inside-top-image-img"
                src="imgs/Profile/editProfile.svg"
              />
            </div>
          </div>
          <div className="School-inside-center">
            <input
              type="text"
              onChange={(e) => setSearchValue(e.target.value)}
              className="School-inside-center-input"
              placeholder="لطفا نام مدرسه خود را بنویسید"
            />
            <ul className="School-inside-center-ul">
              {schoolList.map((item, i) => (
                <li key={item.id}>
                  <input
                    type="radio"
                    hidden
                    id={item.id}
                    onChange={() => setSelectedEducationOption(item)}
                    onClick={() => setSelectedEducationOption(item)}
                    checked={selectedEducationrOption?.name == item.name}
                    name="answer"
                    className="School-inside-center-ul-Option-input"
                    value={item.id}
                  />
                  <label
                    htmlFor={item.id}
                    className="School-inside-center-ul-Option-label"
                  >
                    <div className="School-inside-center-ul-Option-label-inside">
                      <div className="School-inside-center-ul-Option-label-inside-inside-circle">
                        <svg height="40" width="40">
                          <circle cx="20" cy="20" r="10" className="circle" />
                        </svg>
                      </div>
                      <p className="School-inside-center-ul-Option-label-inside-insid-text">
                        {item.name}
                      </p>
                    </div>
                  </label>
                </li>
              ))}
            </ul>
          </div>

          <div className="School-inside-bottom">
            <input
              onClick={() => {
                setEducationValue(selectedEducationrOption);
                close();
              }}
              className="School-inside-bottom-submit"
              type="submit"
              value="ثبت"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default School;
